import type { ResourceOption } from './ResourceSelectField'

const NO_LINK = 'нет связи'

/** Текст пункта списка: нативный `<select>` рисует только текст, поэтому вид и связь названы словами. */
export function resourceOptionText(option: ResourceOption): string {
  const same = option.mark?.trim().toLocaleLowerCase('ru') === option.label.trim().toLocaleLowerCase('ru')
  const named = option.mark === undefined || option.mark === '' || same ? option.label : `${option.mark} · ${option.label}`
  return option.down === true ? `${named} — ${NO_LINK}` : named
}
